import { Button, PrintableAreaRef, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import { isBridgeLoan } from '../../utils/utils';
import { DownloadableQuoteTerm } from './downloadableQuoteTerm';
import { DownloadableQuoteBridge } from './downloadableQuoteBridge';
import { termPortfolioData } from '../../utils/summaryUtils';
import { LoanSubType } from '../../utils/constants';

export type DownloadQuoteDialogProps = {
  open?: boolean;
  onClose?: () => void;
  store?: any;
};

export const DownloadQuoteDialog = observer(
  ({ store, open, onClose }: DownloadQuoteDialogProps) => {
    const ref = useRef<PrintableAreaRef>(null);

    const downloadQuote = () => {
      const propertyAddress: any = getPropertyAddress();
      const pdfName = `${propertyAddress ?? ''} Quote.pdf`;
      ref.current.downloadAsPdf(pdfName);
    };

    const getPropertyAddress = () => {
      if (store.loanSubtype === LoanSubType.RENTAL_PORTFOLIO) {
        return termPortfolioData(store)?.propertyAddress;
      }
      const property: any = store.propertiesStore.getProperties()?.[0];
      return `${property.address?.addressLine2 ?? ''} ${property.address?.addressLine1 ?? ''}`;
    }

    const dialogActions = (
      <>
        <Button
          testId="cancel-download-quote"
          color="primary"
          variant="outlined"
          style={{ marginRight: '8px' }}
          onClick={onClose}
        >
          CANCEL
        </Button>
        <Button
          testId="download-quote"
          color="primary"
          variant="contained"
          onClick={downloadQuote}
        >
          DOWNLOAD
        </Button>
      </>
    );

    return (
      <StandardDialog
        open={open}
        title="Download Quote"
        maxWidth="md"
        handleClose={onClose}
        dialogActions={dialogActions}
        dialogContent={
          isBridgeLoan(store.loanSubtype) ? (
            <DownloadableQuoteBridge store={store} ref={ref} />
          ) : (
            <DownloadableQuoteTerm store={store} ref={ref} />
          )
        }
      />
    );
  }
);
